// Core
import React from 'react';

function RotatePhone(): JSX.Element {
  return (
    <svg viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="12.5"
        y="5"
        width="25"
        height="40"
        rx="4"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <circle
        cx="25"
        cy="9"
        r="1.25"
        fill="currentColor"
      />
      <rect
        x="15"
        y="12"
        width="20"
        height="29"
        rx="1"
        fill="currentColor"
        opacity="0.15"
      />
      <line
        x1="17.5"
        y1="16"
        x2="32.5"
        y2="16"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        opacity="0.4"
      />
      <line
        x1="17.5"
        y1="20"
        x2="30"
        y2="20"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        opacity="0.4"
      />
      <line
        x1="17.5"
        y1="24"
        x2="27.5"
        y2="24"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        opacity="0.4"
      />
      <circle
        cx="25"
        cy="42"
        r="1.5"
        stroke="currentColor"
        strokeWidth="1"
        fill="none"
      />
    </svg>
  );
}

export default RotatePhone;
